import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from 'axios'

import { axiosClient } from "../../helpers/apiClient";
import { 
    getAnnoucement as getAnnoucementUrl
} from "../../helpers/apiUrl";
import { Response } from "../../types/global";
import * as types from "../../types/annoucement";

export const clearAnnoucement = createAction("annoucement/clear")

export const getAnnoucement = createAsyncThunk<types.annoucement[]>("annoucement/get", async()=>{
    return await axiosClient
    .post(getAnnoucementUrl, {})
    .then((response: AxiosResponse<Response<types.annoucement[]>>) => response.data)
    .then((response: Response<types.annoucement[]>) => response.data)
})
